module.exports = __webpack_public_path__ + "static/media/main.0d67cc64.png";